<template>
	<div 
        :class="[
            'zona', 
            {'zona-full-height': views.some(s => s.hook.height && s.hook.height === 'auto')}
        ]"
        v-if="views && views.length">

        <!-- TABS -->
        <template v-if="showtabs">
            <el-tabs v-model="tab">
                <el-tab-pane
                v-for="(tab_view, i) in views"
                :key="i"
                :label="tab_view.nombre"
                :name="tab_view.nombre">

                    <Tablon
                    ref="tablon"
                    :tab="tab_view"
                    :ficha="ficha"
                    :id="id"
                    :activetab="tab"
                    :entidad="entidad"
                    @afterActions="(val) => $emit('afterActions',val)"
                    @saved="saved"
                    @setActionId="setActionId"
                    @setCurrentAction="setCurrentAction"
                    @reloadDataTable="reloadDataTable"
                    @openWindow="val => $emit('openWindow', val)"
                    @dblClickSearch="val => $emit('dblClickSearch',val)" />
                    
                </el-tab-pane>
            </el-tabs>
        </template>

        <!-- PORLET -->
        <template v-else>

            <div 
            :style="{'position': 'relative', 'flex-shrink': view.hook.height && view.hook.height === 'auto' ? 1 : 0}" 
            :class="[{'full-height': view.hook.height && view.hook.height === 'auto'}]" 
            v-for="(view,i) in views">

                <!-- Editor add-row -->
                <Editor :ficha="ficha" type="add-row" />

                <el-row :gutter="15" :key="i" ref="refrow_">
                    <el-col v-for="(column, c) in view.cols" :key="c" :span="column.cols" style="position: relative">

                        <!-- EDITOR -->
                        <Editor :ficha="ficha" type="add-porlet"/>

                        <div v-for="(elemento, e) in column.elementos" style="height: 100%">

                            <Porlet
                            :ref="`porlet_${elemento.id}`"
                            :inputList="inputList"
                            :key="e"
                            :ficha="ficha"
                            :id="id"
                            :entidad="entidad"
                            :porlet="elemento"
                            :elemento="elemento"
                            :showMargin="elemento.attr && elemento.attr.hasOwnProperty('showMargin') ? elemento.attr.showMargin: '0px 0px 0px 0px'"
                            :showHeader="elemento.attr && elemento.attr.hasOwnProperty('showHeader') ? elemento.attr.showHeader : true"
                            :showFooter="elemento.attr && elemento.attr.hasOwnProperty('showFooter') ? elemento.attr.showFooter : true"
                            :showShadow="elemento.attr && elemento.attr.hasOwnProperty('showShadow') ? elemento.attr.showShadow : true"
                            :visible="elemento.attr && elemento.attr.hasOwnProperty('visible') ? elemento.attr.visible : true"
                            :marginBottom="elemento.attr && elemento.attr.hasOwnProperty('marginBottom') ? elemento.attr.marginBottom : true"
                            :height="elemento.attr.height"
                            @setCurrentAction="setCurrentAction"
                            @saved="saved"
                            @setActionId="setActionId"
                            @reloadDataTable="reloadDataTable"
                            @openWindow="val => $emit('openWindow',{entidad, ...val})"
                            @dblClickSearch="val => $emit('dblClickSearch',val)"
                            @refsInputs="(val) => inputList.push(...val)" />
                            
                        </div>

                    </el-col>

                    <!-- EDITOR -->
                    <Editor :params="view" :ficha="ficha" type="row"/>
                </el-row>
            </div>
        </template>
		
	</div>
</template>

<script>
    import Tablon from '@/components/Tablon.vue'
    import Editor from '@/components/Editor/Editor.vue'
   
	export default {
		name: 'Zona',
		components: {
            Tablon,
            Editor
		},
		props: {
            id: [Number,String],
            ficha: Object,
            entidad: String,
            views: Array,
			showtabs: {
                type: Boolean,
                required: false,
                default: () => false
            }
		},
		data () {
			return {
				tab: '',
                inputList: []
			}
        },
        watch: {
            views() {
                this.setDefaultTab()
            }
        },
        mounted() {
           this.setDefaultTab()
        },
        methods: {

            // EMITS
            saved(data) {
                this.$emit('saved',data)
            },
            setActionId(data) {
                this.$emit('setActionId',data)
            },
            setCurrentAction(data) {
                this.$emit('setCurrentAction',data)
            },
            reloadDataTable(data) {
                this.$emit('reloadDataTable', data)
            },

            // PORLET
            /*getInputListFromTab() {
                let list = []
                setTimeout(() => {

                    let refs = Object.keys(this.$refs)
                    let _self = this

                    if (refs.length) {
                        refs.forEach((porlet) => {
                            
                            _self.$addRef(porlet, _self.$refs[porlet][0])

                            let inputs = _self.$refs[porlet][0].$children.filter(f => f.$refs.input)
                            if (inputs && inputs.$refs && inputs.$refs.input && inputs.$refs.input.length) {
                                inputs.$refs.input
                                .filter(el => !el.readonly  && !(el.hasOwnProperty('visible') && !el.visible ))
                                .forEach(input => {
                                    list.push(input)
                                })
                            }
                        })

                        // Comprobar alturas porlets
                        refs.forEach((porlet) => {
                            
                            let refporlet = _self.$referencias[porlet].porlet
                            if(refporlet && refporlet.idPorletHeight) {
                                _self.$referencias[porlet].$el.style.height = `${_self.$referencias[`porlet_${refporlet.idPorletHeight}`].$el.clientHeight}px`
                            }
                        })
                    }
                },200)
               
                return list
            },*/

            // TABS
            setDefaultTab() {
                if (this.showtabs && this.views.length && this.tab == '0') this.tab = this.views[0].nombre
            }
        }
	}
</script>

<style lang="scss">
.zona {
    flex-shrink: 0;
    &.zona-full-height {
        display: flex;
        flex-grow: 1;
        flex-flow: column;
        overflow: hidden;
        .full-height {
            display: flex;
            flex-grow: 1;
            > .el-row {
                display: flex;
                flex-grow: 1;
                > .el-col {
                    display: flex;
                    flex-grow: 1;
                    > div {
                        display: flex;
                        flex-grow: 1;
                    }
                }
            }
        }
    }
    .el-tabs {
        .el-tabs__header {
            padding: 0px 15px;
            background-color: white;
            flex-shrink: 0;
            &.is-top {
                box-shadow: 0 2px 4px rgba(0,0,0,.15), 0 0 1px rgba(0,0,0,.08);
            }
            .el-tabs__nav-wrap {
                z-index: 0!important;
                &::after {
                    background-color: #ffffff;
                }
            }
        }
        .el-tabs__content {
            padding: 0px 15px;
        }
    }
}
</style>